import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

const bePutSalonFlagSettings = actionBe('bePutSalonFlagSettings', ({ AT, ATAG, data }) =>
  endpoint(H.put, 'salon/v2/:salonId/flags/settings/', {
    AT,
    name: ATAG,
    data,
  }),
);

export default bePutSalonFlagSettings;
